<!--eslint-disable-->
<sellerMenu class="float-left" />
<template>
  <div class="marketingList seller-style">
    <h2 class="f18 fb normal gray_2">营销管理</h2>
    <div class="marketingList_main clear relative b_white f14">
      <div class="clear">
        <span class="pull-left gray_2 f14">营销策略列表</span>
        <div class="pull-right clear">
          <el-button plain class="f16" @click="toAddMarketingDirect"> 手动发放 </el-button>
          <el-button type="primary" class="f16" @click="toAddMarketingStrategy"><span class="f22 lin_25">+</span> 添加营销策略</el-button>
        </div>
      </div>
      <div class="box30"></div>
      <div class="marketing_table f14 t_center">
        <table cellpadding="0" cellspacing="0" class="marketing_table_head">
          <thead>
            <tr>
              <!--             <td width="100" class=" text-center">-->
              <!--              <input type="hidden" class="allChks" value="">-->
              <!--              <div class="clear z_peisong SelAll">-->
              <!--                <a href="javascript:void(0)" class=""></a>-->
              <!--              </div>-->
              <!--            </td>-->
              <td width="200">营销策略名称</td>
              <td width="340">有效期</td>
              <td width="120">状态</td>
              <td width="" class="text-center">
                <span>操作</span>
              </td>
            </tr>
          </thead>
        </table>
        <table cellpadding="0" cellspacing="0" border="0">
          <tbody>
            <tr v-for="item in marketingList" v-bind:key="item.id">
              <!--            <td width="100">-->
              <!--              <div class="clear z_peisong d_chks">-->
              <!--                <a href="javascript:void(0)" class=""></a>-->
              <!--              </div>-->
              <!--            </td>-->
              <td width="200">{{ item.marketingName }}</td>
              <td width="340">{{ item.startTimeStr }} 至 {{ item.endTimeStr }}</td>
              <td width="120">{{ item.activeStateCN }}</td>
              <td width="">
                <el-button @click="lookDetail(item)">查看</el-button>
                <el-button v-if="item.activeState != 'HAVE_IN_HAND'" @click="delMarketing(item)">删除</el-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="box30"></div>
        <!--分页start-->
        <div class="pages text-right">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="[10, 20, 30]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.totalCount"
          >
          </el-pagination>
        </div>
        <!--分页end-->
      </div>
    </div>
    <el-dialog title="营销详情" :visible.sync="dialogVisible" width="50%">
      <div class="clear">
        <span class="float-left marketing_head f14">营销策略名称:</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <span class="pad20_r">{{ marketingDetail.marketingName }}</span>
          </p>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head f14">营销客户:</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <span class="pad20_r" v-if="marketingDetail.customerType === 'ALL'">所有人群</span>
            <span class="pad20_r" v-else-if="marketingDetail.customerType === 'GROUPING'">按客户分组</span>
            <span class="pad20_r" v-else-if="marketingDetail.customerType === 'CUSTOMER'">按指定客户</span>
          </p>
        </div>
      </div>
      <div class="clear" v-if="marketingDetail.customerType === 'GROUPING' || marketingDetail.customerType === 'CUSTOMER'">
        <span class="float-left marketing_head f14">{{ marketingDetail.customerType == "GROUPING" ? "客户分组:" : "指定客户:" }}</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <el-tag type="info" class="pad20_r" style="margin-right: 10px" v-for="(group, index) in marketingDetail.customerGroupList" :key="index">
              {{ group.name }}</el-tag
            >
          </p>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head f14">营销类型:</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <span class="pad20_r">优惠券</span>
          </p>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head f14">营销优惠券</span>
        <div class="float-left coupon_list">
          <ul class="clear f12 white">
            <li v-for="coupon in marketingDetail.coupRegularResList" v-bind:key="coupon.regCode">
              <div class="clear coupon_price">
                <span class="float-left f24">￥{{ coupon.regVal }}</span>
                <div class="float-right t_right">
                  <p>满{{ coupon.regKey }}元可用</p>
                  <p v-if="coupon.busType === 'SHOP'">全部货品可用</p>
                  <p v-if="coupon.busType === 'GOODS'">指定货品可用</p>
                  <p v-if="coupon.busType === 'CATE'">指定分类可用</p>
                </div>
              </div>
              <p class="t_center">领取时间：{{ coupon.startTimeStr }}至{{ coupon.endTimeStr }}</p>
              <p class="t_center">使用时间：{{ coupon.useStartTimeStr }}至{{ coupon.useEndTimeStr }}</p>
              <div class="clear coupon_num gray_3">
                <span class="float-left"
                  >数量：<em class="red">{{ coupon.surplusNum }}</em></span
                >
                <span class="float-right" v-if="coupon.residueEndDay">即将到期</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head f14">营销条件:</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <template v-if="marketingDetail.strategyRule !== 'TOTAL'">
              <span class="pad20_r" v-if="marketingDetail.strategyCondition === 'ORDER_QUANTITY'"
                >订单数量满 {{ marketingDetail.operatorAmountQuantity }} 件</span
              >
              <span class="pad20_r" v-if="marketingDetail.strategyCondition === 'ORDER_AMOUNT'">订单金额 {{ marketingDetail.operatorAmountQuantity }} 元</span>
            </template>
            <template v-else>
              <span class="pad20_r" v-if="marketingDetail.strategyCondition === 'ORDER_QUANTITY'"
                >累计商品交易 {{ marketingDetail.operatorAmountQuantity }} 件</span
              >
              <span class="pad20_r" v-if="marketingDetail.strategyCondition === 'ORDER_AMOUNT'">累计消费 {{ marketingDetail.operatorAmountQuantity }} 元</span>
            </template>
          </p>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head f14">营销货品:</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <span class="pad20_r" v-if="marketingDetail.strategyGoods === 'ALL'">全部货品</span>
            <span class="pad20_r" v-else-if="marketingDetail.strategyGoods === 'APPOINT'">指定货品</span>
          </p>
        </div>
      </div>
      <div class="clear" v-if="marketingDetail.strategyGoods === 'APPOINT'">
        <span class="float-left marketing_head f14">货品列表</span>
        <div class="float-left">
          <el-tag type="info" class="pad20_r" style="margin-right: 10px" v-for="goods in marketingDetail.goodsList" v-bind:key="goods.goodsId">
            {{ goods.name }}
          </el-tag>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head f14">有效时间:</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <span class="pad20_r">{{ marketingDetail.startTime }} 至 {{ marketingDetail.endTime }}</span>
          </p>
        </div>
      </div>
      <div class="clear">
        <span class="float-left marketing_head f14">发放方式:</span>
        <div class="float-left">
          <p class="f14 lin_30">
            <span class="pad20_r" v-if="marketingDetail.marketingGrantType === 1">支付完成后发放</span>
            <span class="pad20_r" v-else-if="marketingDetail.marketingGrantType === 2">卖家发货后发放</span>
            <span class="pad20_r" v-else-if="marketingDetail.marketingGrantType === 3">确认收货后发放</span>
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      marketingList: [],
      pagination: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
      },
      dialogVisible: false,
      marketingDetail: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {},

  mounted() {
    this.listMarketing();
  },
  // 监听器
  filters: {},
  methods: {
    toAddMarketingDirect() {
      this.$router.push({
        path: "/mj/addMarketing/DIRECT",
      });
    },
    toAddMarketingStrategy() {
      this.$router.push({
        path: "/mj/addMarketing/STRATEGY",
      });
    },
    listMarketing() {
      this.$store
        .dispatch("shop/shopMarketing/getMarketingList", {
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        })
        .then((data) => {
          if (data) {
            this.marketingList = data.shopMarketingList;
            this.pagination.totalCount = data.totalCount;
            console.log(this.marketingList);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.listMarketing();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.listMarketing();
    },
    // 删除
    delMarketing(item) {
      this.$store.dispatch("shop/shopMarketing/delMarketing", item.id).then((res) => {
        if (res !== null && res.code === "0") {
          this.$message.success(res.msg);
          this.listMarketing();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    lookDetail(item) {
      this.$store.dispatch("shop/shopMarketing/getMarketing", item.id).then((res) => {
        if (res !== null && res.code === "0") {
          this.marketingDetail = res.data;
          console.log(this.marketingDetail);
          this.dialogVisible = true;
        } else if (res !== null && res.code !== "0") {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
